import { Box } from '@chakra-ui/react'
import { SupportArticlesList } from '@src/components/sco/SupportArticlesList'
import { Block } from '@src/pages/landing/first-10k.tsx'
import { PageWithNavBar } from '@src/templates/PageWithNavBar.tsx'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default function Page() {
  return (
    <PageWithNavBar>
      <Block headingProps={{ children: 'Help Articles' }}>
        <Box marginX={'auto'} maxWidth={'container.md'}>
          <SupportArticlesList />
        </Box>
      </Block>
    </PageWithNavBar>
  )
}
